import { Form } from './Form'
import { Header } from './Header'

const Step5 = {
  Header,
  Form,
}

export default Step5
